export default __webpack_public_path__ + "static/media/MainLandingPageHero.f9e6f9cc.png";